import React, { useState } from "react";
import ModalSkeleton from "../../../../ModalSkeleton/ModalSkeleton";
import css from "./SavedFilterModal.module.css";
import { Button } from "../../../../../stories/Button/Button";
import { Row, Col } from "react-bootstrap";
import Fonts from "../../../../../stories/assets/Fonts";
import {
  CancelIconBlack,
  TrashIconGray,
} from "../../../../../constant/imagePath";
import Colors from "../../../../../stories/assets/Colors";
import { ReactSVG } from "react-svg";
import ModalSkeletonCssClasses from "../../../../ModalSkeleton/ModalSkeleton.module.css";
import { SaveFilterComponent } from "../../../../../stories/SaveFilterComponent/SaveFilterComponent";

const SavedFilterModal = ({ show, setShow }) => {
  const [filterData, setFilterData] = useState([
    {
      id: 1,
      title: "Royal Tennis Court",
    },
    {
      id: 2,
      title: "Green Tennis Court",
    },
    {
      id: 3,
      title: "Green Tennis Court",
    },
    {
      id: 4,
      title: "Royal Tennis Court",
    },
  ]);

  const handleDelete = (index) => {
    const newArr = filterData.filter((item, i) => i !== index);
    setFilterData(newArr);
  };
  return (
    <>
      <style>{`
      .${ModalSkeletonCssClasses.body} {
        padding: 0px;
      }
          .modal .modal-dialog {
            width: 100% !important;
            margin: 0px !important;
          }
          .modal .modal-dialog {
            max-width: 100% !important;
            height: 100%;
        }
        .modal-content{
            min-height:100%
        }
        .modal { 
            border-radius: 0px;
            background: white;
          }
    `}</style>
      <ModalSkeleton
        show={show}
        setShow={setShow}
        hideHeaderBorder
        borderRadius={"0px"}
        width={"100%"}
      >
        <Row className="g-0">
          <Col sm={12}>
            <div
              style={{
                borderBottom: `1px solid ${Colors.neutralShadesOfGainsboro}`,
              }}
              className={[css.FilterHeader].join(" ")}
            >
              <ReactSVG
                src={CancelIconBlack}
                // onClick={() => setIsSavedFilter(false)}
              />

              <h6
                style={{
                  ...Fonts.b3,
                  color: Colors.neutralShadesOfNero,
                }}
              >
                Saved Filters
              </h6>
              <div />
            </div>
          </Col>
          <Col sm={12}>
            <ul className={css.filters}>
              {filterData.map((item, index) => {
                return (
                  <li>
                    <p
                      style={{
                        color: Colors.neutralShadesOfNero,
                        ...Fonts.b1Mobile,
                      }}
                    >
                      {item?.title}
                    </p>
                    <div>
                      <ReactSVG
                        src={TrashIconGray}
                        beforeInjection={(svg) => svg.classList.add(css.icon)}
                      />
                    </div>
                  </li>
                );
              })}
            </ul>
          </Col>
          <div
            style={{ backgroundColor: Colors.white }}
            className={[css.saveFilterBtnDiv].join(" ")}
          >
            <Button
              label={"Save new Filter"}
              customStyle={{
                ...Fonts.b1,
                padding: "12px 32px",
                border: `1px solid ${Colors.neutralShadesOfGainsboro}`,
                width: "100%",
              }}
              size="Large"
            />
          </div>
        </Row>
      </ModalSkeleton>
    </>
  );
};
export default SavedFilterModal;
